export const COPARTICIPATION_API_BASE = '/statement';

export const COPARTICIPATION_FILTER_API_BASE = '/analytics-bff';

export const COPARTICIPATION_ENDPOINTS = {
  records: '/v1/internal/records',
  exportReport: '/v1/internal/records/create-report-async',
  findReport: '/report/find-report',
};

export const COPARTICIPATION_STATEMENT_TYPE = 'COPARTICIPATION';
export const COPARTICIPATION_REPORT_TYPE = 'REPORT_STATEMENT';

export const COPAY_EXEMPT_OPTIONS = [
  { value: 'ALL', i18nKey: 'all' },
  { value: 'YES', i18nKey: 'yes' },
  { value: 'NO', i18nKey: 'no' },
] as const;

export const mapCopayExemptOptionToFilter = (value: string | null): boolean | null => {
  if (value === 'YES') return true;
  if (value === 'NO') return false;
  return null;
};

export const mapCopayExemptFilterToOption = (value: boolean | null): string => {
  if (value === true) return 'YES';
  if (value === false) return 'NO';
  return 'ALL';
};
